import { render } from "./WordInfo.vue?vue&type=template&id=21d11f2a&scoped=true"
import script from "./WordInfo.vue?vue&type=script&lang=js"
export * from "./WordInfo.vue?vue&type=script&lang=js"

import "./WordInfo.vue?vue&type=style&index=0&id=21d11f2a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d11f2a"]])

export default __exports__